class SlideoutMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.viewModel = this.getViewModel(this);
    this.menuItems = this.querySelectorAll('.drawer-item-collapsible .navigation-drawer__button');
    this.slideSubmenus = this.querySelectorAll('.submenu.slide-in');
  }

  connectedCallback() {
    this.initMenu();
    this.initModalProxy();
    this.syncDesktopMenu();
  }

  initMenu() {
    this.setupMenuInteractions();
    this.setupBackButtons();
  }

  initModalProxy() {
    const { $modal } = this.viewModel;
    if (!$modal) return;

    this.proxyModalMethod($modal, 'close', () => this.closeAllSubmenus());
    this.proxyModalMethod($modal, 'open', () => {
      this.disableAnimationTemporary();
    });
  }

  proxyModalMethod(modal, methodName, callback) {
    const originalMethod = modal[methodName].bind(modal);
    modal[methodName] = (...args) => {
      callback();
      return originalMethod(...args);
    };
  }

  setupMenuInteractions() {
    this.menuItems.forEach((menuItem) => {
      const submenu = this.getSubmenuFromToggle(menuItem);
      if (!submenu) return;

      menuItem.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleSubmenu(submenu, menuItem);
      });
    });
  }

  setupBackButtons() {
    this.querySelectorAll('.slideout-menu-drawer__back-button').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const submenu = event.currentTarget.closest('.submenu');
        this.closeSubmenu(submenu);
      });
    });
  }

  getSubmenuFromToggle(toggleButton) {
    return toggleButton.closest('toggleable-icon-button')?.nextElementSibling;
  }

  getToggleFromSubmenu(submenu) {
    const parent_data_id = submenu.id.replace('submenu-', '');
    return document.querySelector(`.menu-item-container [data-id="${parent_data_id}"]`);
  }

  openSubmenu(submenu, toggle) {
    submenu.classList.add('open');
    toggle?.classList.add('is-active');
    toggle?.setAttribute('aria-expanded', 'true');
    this.toggleTopMenuScroll();
  }

  closeSubmenu(submenu) {
    const toggle = this.getToggleFromSubmenu(submenu);
    submenu.classList.remove('open', 'block-scroll');
    toggle?.classList.remove('is-active');
    toggle?.setAttribute('aria-expanded', 'false');
    this.toggleTopMenuScroll();
  }

  toggleSubmenu(submenu, toggle) {
    const isOpen = submenu.classList.contains('open');
    isOpen ? this.closeSubmenu(submenu) : this.openSubmenu(submenu, toggle);
  }

  closeAllSubmenus() {
    this.slideSubmenus.forEach((submenu) => this.closeSubmenu(submenu));
  }

  toggleTopMenuScroll() {
    this.viewModel.$topLevelContent?.classList?.toggle('block-scroll');
  }

  disableAnimationTemporary() {
    this.viewModel.$navigation?.classList.add('no-animation');
    setTimeout(() => {
      this.viewModel.$navigation?.classList.remove('no-animation');
    }, 400);
  }

  syncDesktopMenu() {
    document.querySelectorAll('.desktop-main-menu .desktop-menu__item-link .text-button__button').forEach((link) => {
      const identifier = link.getAttribute('data-id');
      const submenu = this.viewModel.$mobileDrawer?.querySelector(`#submenu-${identifier}`);
      if (!submenu) return;

      //Accessibilize!
      link.setAttribute('aria-haspopup', true);
      link.setAttribute('aria-expanded', false);

      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.disableAnimationTemporary();
        this.openSubmenu(submenu, this.getToggleFromSubmenu(submenu));
        this.viewModel.$modal?.open?.();
      });
    });
  }

  getViewModel(scope) {
    return {
      $modal: scope.closest('.mobile-nav-slideout'),
      $navigation: scope.querySelector('.slideout-menu-drawer__navigation'),
      $topLevelContent: scope.closest('.side-slideout__content'),
      $mobileDrawer: document.getElementById('mobile-nav-slideout'),
    };
  }
}

customElements.define('slideout-menu-drawer', SlideoutMenuDrawer);
